// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"67287059","977":"7dd98a20"}[chunkId] + ".chunk.js";
};